const isCypress = typeof window.Cypress !== 'undefined'
import { EventBus } from '~/plugins/eventbus.js'

export default ({ store }) => {
  if (isCypress) {
    window.store = store
    window.eventBus = EventBus
  }
}